export default __webpack_public_path__ + "img/bg-d608e5d4.png";